import { useEffect } from 'react';

const ScrollReveal = () => {
    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.15
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        const revealElements = document.querySelectorAll('.reveal');
        revealElements.forEach(el => {
            observer.observe(el);
        });

        return () => {
            revealElements.forEach(el => {
                observer.unobserve(el);
            });
        };
    }, []);

    return null;
};

export default ScrollReveal;
